export default "__VITE_ASSET__Bga18IJN__"